import { createModulePage } from '../../../components/generic/createModulePage';
import { initializeModule } from '../../../utils/configInit';
import { trainingConfig } from './trainingConfig';
import { createTrainingValidation } from './trainingValidation';

/**
 * Initialize the Training module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  trainingConfig,
  createTrainingValidation
);

/**
 * Create the TrainingPage using the generic module page factory
 */
const TrainingPage = createModulePage(
  initializedConfig,
  {
    displayName: 'TrainingPage',
    description: 'Training Management System - Create and manage training courses'
  }
);

export default TrainingPage;

